<script setup lang="ts">
import type { SectionMediaBlockRecord } from '~/types/datocms'

const props = defineProps<{
  data: SectionMediaBlockRecord
}>()

const { invertedStyles } = useSectionRules(undefined, props.data.invertColorTheme)
</script>

<template>
  <div class="container grid-default pb-15 pt-12 lg:pb-20 lg:pt-40" :class="invertedStyles">
    <div
      class="col-span-12 lg:col-span-6"
      :class="data.mediaPosition === 'Left' ? 'lg:order-1' : 'lg:order-2 lg:col-start-7'"
    >
      <Image
        loading="lazy"
        class="aspect-4/3 w-full"
        sizes="(min-width: 1040px) calc(50vw - 56px), calc(100vw - 32px)"
        :src="data.media.responsiveImage ? data.media.responsiveImage?.src : data.media.url"
        :srcset="data.media.responsiveImage ? data.media.responsiveImage?.webpSrcSet : undefined"
        :width="data.media.responsiveImage ? data.media.responsiveImage?.width : data.media.width"
        :height="
          data.media.responsiveImage ? data.media.responsiveImage?.height : data.media.height
        "
        :alt="data.media.alt"
      />
    </div>
    <div
      class="col-span-12 lg:col-span-6 lg:flex lg:flex-col lg:justify-center xl:col-span-5"
      :class="
        data.mediaPosition === 'Left'
          ? 'lg:order-2 lg:pl-8 xl:col-start-8 xl:pl-0'
          : 'lg:order-1 lg:pr-8 xl:pr-0'
      "
    >
      <div>
        <div v-if="data.title" class="mb-8 text-3xl-bl uppercase lg:mb-12 lg:text-5xl-bl">
          <TextReveal>{{ data.title }}</TextReveal>
        </div>
        <div v-if="data.html" class="mb-5" v-html="data.html" />
        <CallToAction
          v-if="Array.isArray(data.buttons) && data.buttons.length"
          class="ml-0 mt-8 lg:mt-12"
          :data="data.buttons"
        />
      </div>
    </div>
  </div>
</template>
